// Stripe types and enums
export const StripePlan = {
  REGULAR: 'regular',
  BUSINESS: 'business',
  STUDENT: 'student', // Just used for CB migration. Not used in Stripe subscriptions
  BUSINESS_TEAMS: 'business_teams',
} as const;

export type StripePlan = (typeof StripePlan)[keyof typeof StripePlan];

export const StripeInterval = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
} as const;

export type StripeInterval = (typeof StripeInterval)[keyof typeof StripeInterval];
